import React from "react";

interface LoadingProps {
    label?: string;
}

export class Loading extends React.Component<LoadingProps>
{
    render() {
        return (
            <div className="text-center">
                <i className="fas fa-sync fa-spin center-block fa-5x" style={{ marginTop: 150 }} />
                <h3 style={{ color: "#888888" }}>{this.props.label || "loading..."}</h3>
            </div>)
    }
}


interface LoadingComponentProps {
    label?: string;
    isLoading: boolean;
}

export const LoadingComponent: React.FunctionComponent<LoadingComponentProps> = props => props.isLoading ? <Loading label={props.label} /> : <>{props.children}</>;